/*
 * EarthBreath Contact file upload (Cloudinary unsigned)
 * Загрузка вложений (фото-доказательства повреждений) в Cloudinary
 * до отправки нативной contact-формы Shopify. Ссылки на файлы
 * подставляются в скрытое поле и приходят магазину на почту.
 */
(function () {
  'use strict';

  // Версия скрипта для отслеживания изменений
  var EB_CONTACT_UPLOAD_VERSION = '1.0.0';

  // v1.0.0 — единая точка инициализации всех контакт-форм с загрузкой
  function ebContactUploadInit() {
    var roots = document.querySelectorAll('[data-eb-contact-upload]');
    for (var i = 0; i < roots.length; i++) {
      ebSetupForm(roots[i]);
    }
  }

  // v1.0.0 — настройка одной формы: валидация, загрузка, блокировка submit
  function ebSetupForm(root) {
    if (root.dataset.ebReady === 'true') return;
    root.dataset.ebReady = 'true';

    var cloudName = root.dataset.cloudName;
    var preset = root.dataset.uploadPreset;
    var maxSize = (parseInt(root.dataset.maxSize, 10) || 10) * 1024 * 1024; // байты
    var maxFiles = parseInt(root.dataset.maxFiles, 10) || 5;
    var t = ebParseJson(root.dataset.i18n) || {};

    var input = root.querySelector('[data-eb-file-input]');
    var hidden = root.querySelector('[data-eb-file-urls]');
    var list = root.querySelector('[data-eb-file-list]');
    var status = root.querySelector('[data-eb-file-status]');
    var form = root.closest('form');

    if (!input || !hidden || !form) return;

    // Конфиг не задан — поле выключаем, чтобы не вводить покупателя в заблуждение
    if (!cloudName || !preset) {
      input.disabled = true;
      ebSetStatus(status, t.config_error || 'File upload is not configured.', 'error');
      return;
    }

    var allowedExt = ['jpg', 'jpeg', 'png', 'pdf', 'doc', 'docx'];
    var uploaded = []; // {name, url}
    var pending = 0;

    input.addEventListener('change', function () {
      var files = Array.prototype.slice.call(input.files || []);
      input.value = ''; // позволяем выбрать тот же файл повторно

      for (var i = 0; i < files.length; i++) {
        if (uploaded.length + pending >= maxFiles) {
          ebSetStatus(status, ebFormat(t.too_many, { count: maxFiles }), 'error');
          break;
        }
        ebHandleFile(files[i]);
      }
    });

    // v1.0.0 — валидация и загрузка одного файла
    function ebHandleFile(file) {
      var ext = (file.name.split('.').pop() || '').toLowerCase();
      if (allowedExt.indexOf(ext) === -1) {
        ebSetStatus(status, ebFormat(t.bad_type, { name: file.name }), 'error');
        return;
      }
      if (file.size > maxSize) {
        ebSetStatus(status, ebFormat(t.too_big, { name: file.name, mb: Math.round(maxSize / 1048576) }), 'error');
        return;
      }

      var row = ebAddRow(list, file.name, t.uploading || 'Uploading…');
      pending++;
      ebToggleSubmit(form, true);

      var data = new FormData();
      data.append('file', file);
      data.append('upload_preset', preset);

      var xhr = new XMLHttpRequest();
      xhr.open('POST', 'https://api.cloudinary.com/v1_1/' + cloudName + '/auto/upload');
      xhr.onload = function () {
        pending--;
        var ok = false;
        if (xhr.status >= 200 && xhr.status < 300) {
          var res = ebParseJson(xhr.responseText);
          if (res && res.secure_url) {
            uploaded.push({ name: file.name, url: res.secure_url });
            ebUpdateRow(row, t.done || 'Uploaded', 'ok', res.secure_url, function () {
              ebRemoveUploaded(res.secure_url);
            });
            ebSyncHidden();
            ok = true;
          }
        }
        if (!ok) {
          ebUpdateRow(row, t.failed || 'Upload failed', 'error');
        }
        ebFinishIfIdle();
      };
      xhr.onerror = function () {
        pending--;
        ebUpdateRow(row, t.failed || 'Upload failed', 'error');
        ebFinishIfIdle();
      };
      xhr.send(data);
    }

    // v1.0.0 — удаление уже загруженного файла из списка ссылок
    function ebRemoveUploaded(url) {
      for (var i = 0; i < uploaded.length; i++) {
        if (uploaded[i].url === url) { uploaded.splice(i, 1); break; }
      }
      ebSyncHidden();
    }

    // v1.0.0 — синхронизация скрытого поля со списком ссылок
    function ebSyncHidden() {
      var lines = [];
      for (var i = 0; i < uploaded.length; i++) {
        lines.push(uploaded[i].name + ': ' + uploaded[i].url);
      }
      hidden.value = lines.join('\n');
    }

    function ebFinishIfIdle() {
      if (pending === 0) {
        ebToggleSubmit(form, false);
        if (uploaded.length > 0) {
          ebSetStatus(status, ebFormat(t.ready, { count: uploaded.length }), 'ok');
        } else {
          ebSetStatus(status, '', '');
        }
      }
    }

    // Не даём отправить форму, пока идёт загрузка
    form.addEventListener('submit', function (e) {
      if (pending > 0) {
        e.preventDefault();
        ebSetStatus(status, t.wait || 'Please wait for files to finish uploading.', 'error');
      }
    });
  }

  /* ---------- helpers ---------- */

  function ebParseJson(str) {
    if (!str) return null;
    try { return JSON.parse(str); } catch (e) { return null; }
  }

  function ebFormat(tpl, vars) {
    if (!tpl) return '';
    return tpl.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, k) {
      return vars[k] != null ? vars[k] : '';
    });
  }

  function ebSetStatus(el, msg, kind) {
    if (!el) return;
    el.textContent = msg || '';
    el.className = 'eb-contact-upload__status' + (kind ? ' eb-contact-upload__status--' + kind : '');
  }

  function ebAddRow(list, name, label) {
    if (!list) return null;
    var row = document.createElement('li');
    row.className = 'eb-contact-upload__item';
    row.innerHTML = '<span class="eb-contact-upload__name"></span>' +
      '<span class="eb-contact-upload__state"></span>';
    row.querySelector('.eb-contact-upload__name').textContent = name;
    row.querySelector('.eb-contact-upload__state').textContent = label;
    list.appendChild(row);
    return row;
  }

  function ebUpdateRow(row, label, kind, url, onRemove) {
    if (!row) return;
    var state = row.querySelector('.eb-contact-upload__state');
    state.textContent = label;
    row.className = 'eb-contact-upload__item eb-contact-upload__item--' + (kind || '');
    if (url && onRemove && !row.querySelector('.eb-contact-upload__remove')) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'eb-contact-upload__remove';
      btn.setAttribute('aria-label', 'Remove');
      btn.textContent = '×';
      btn.addEventListener('click', function () {
        onRemove();
        row.parentNode.removeChild(row);
      });
      row.appendChild(btn);
    }
  }

  function ebToggleSubmit(form, disabled) {
    var btn = form.querySelector('button[type="submit"]');
    if (btn) {
      btn.disabled = disabled;
      btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ebContactUploadInit);
  } else {
    ebContactUploadInit();
  }
})();
